"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this._listeners = {};
    }
    EventEmitter.prototype.on = function (event, fn) {
        var _this = this;
        this._listeners[event] = this._listeners[event] || [];
        this._listeners[event].push(fn);
        var isSubscribed = true;
        return function () {
            if (isSubscribed) {
                _this._listeners[event] = _this._listeners[event].filter(function (_fn) { return _fn !== fn; });
                isSubscribed = false;
            }
        };
    };
    EventEmitter.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var listeners = this._listeners[event];
        if (listeners) {
            listeners.forEach(function (fn) {
                fn.apply(void 0, args);
            });
        }
    };
    return EventEmitter;
}());
exports.default = EventEmitter;
//# sourceMappingURL=EventEmitter.js.map